'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');
var mapGl = require('@wsp/map-gl');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var loadExternalScript = function loadExternalScript(_ref) {
  var elementId = _ref.elementId,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? "body" : _ref$position,
      scriptSource = _ref.scriptSource,
      onLoad = _ref.onLoad;
  var existingScript = document.getElementById(elementId);

  if (!existingScript) {
    var script = document.createElement("script");
    script.src = scriptSource;
    script.id = elementId;

    if (position === "head") {
      document.head.appendChild(script);
    } else {
      document.body.appendChild(script);
    }

    script.onload = onLoad;
  } else {
    /*If the script had been added already to dom, 
    rerendering caused due to tab switch in same window doesn't call init method of map. Hence, map doesn't renders again. */
    window.google && onLoad();
  }
};

var useMap = function useMap(_ref2) {
  var apiKey = _ref2.apiKey,
      mapConfig = _ref2.mapConfig,
      isMapLoaded = _ref2.isMapLoaded,
      setIsMapLoaded = _ref2.setIsMapLoaded,
      libraries = _ref2.libraries;
  var ref = React.useRef();

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isSdkLoaded = _useState2[0],
      setSdkLoaded = _useState2[1];

  React.useEffect(function () {
    if (isSdkLoaded) {
      var timer = setInterval(function () {
        var _window, _window$mapGL, _window$mapGL$map, _window$mapGL$map$map;

        if (window.google && (_window = window) !== null && _window !== void 0 && (_window$mapGL = _window.mapGL) !== null && _window$mapGL !== void 0 && (_window$mapGL$map = _window$mapGL.map) !== null && _window$mapGL$map !== void 0 && (_window$mapGL$map$map = _window$mapGL$map.mapOverlay) !== null && _window$mapGL$map$map !== void 0 && _window$mapGL$map$map._deck) {
          setIsMapLoaded(true);
          clearInterval(timer);
        }
      }, 200);
    }
  }, [isSdkLoaded]);

  var onLoad = function onLoad() {
    setSdkLoaded(true);
  };

  function initialiseMap() {
    var mapControlObj = new mapGl.MapGL({
      mapConfig: mapConfig
    });

    if (mapControlObj) {
      mapControlObj.init(ref.current);
      window["mapGL"] = mapControlObj;
    }
  }

  React.useEffect(function () {
    /* checks if google map is already present in the current window, it will not fetch another reference again */
    if (apiKey && !isSdkLoaded) {
      var librariesToAdd = libraries ? libraries : "places,drawing";
      var scriptSource = "https://maps.googleapis.com/maps/api/js?key=".concat(apiKey, "&libraries=").concat(librariesToAdd);
      loadExternalScript({
        elementId: "googleMaps",
        scriptSource: scriptSource,
        onLoad: onLoad
      });
    }
  });
  React.useEffect(function () {
    if (isSdkLoaded) {
      initialiseMap();
    }
  }, [isSdkLoaded, mapConfig]);
  React.useEffect(function () {
    if (isMapLoaded && mapConfig.fullscreenControl) {
      var map = window["mapGL"].getMapInstance();
      map.setOptions({
        fullscreenControl: true,
        fullscreenControlOptions: mapConfig === null || mapConfig === void 0 ? void 0 : mapConfig.fullscreenControlOptions
      });
    }
  }, [isMapLoaded, mapConfig.fullscreenControl, mapConfig.fullscreenControlOptions]);
  return {
    ref: ref
  };
};

var DEFAULT_MAP_CONFIG = {
  zoom: 5,
  maxZoom: 15,
  minZoom: 3,
  centerPoint: {
    Lat: 42.4260159,
    Lon: -96.0774279
  },
  clickableIcons: false,
  zoomControlOptions: {
    style: "1",
    position: "9"
  },
  zoomControl: true,
  mapTypeControl: true,
  draggableCursor: "default",
  streetViewControl: true,
  disableDefaultUI: true,
  mapStyles: [],
  fullscreenControl: false,
  fullscreenControlOptions: null,
  tilt: 0
};

var Map = function Map(_ref) {
  var apiKey = _ref.apiKey,
      height = _ref.height,
      width = _ref.width,
      mapConfig = _ref.mapConfig,
      position = _ref.position,
      isMapLoaded = _ref.isMapLoaded,
      setIsMapLoaded = _ref.setIsMapLoaded,
      libraries = _ref.libraries;

  if (!apiKey) {
    throw new Error("API key is mandatory to run this application. Please pass a valid key");
  }

  var _useMap = useMap({
    apiKey: apiKey,
    mapConfig: _objectSpread2(_objectSpread2({}, DEFAULT_MAP_CONFIG), mapConfig),
    isMapLoaded: isMapLoaded,
    setIsMapLoaded: setIsMapLoaded,
    libraries: libraries
  }),
      ref = _useMap.ref;

  return /*#__PURE__*/React__default['default'].createElement("div", {
    style: {
      height: height,
      width: width,
      position: position
    },
    id: "map",
    ref: ref
  });
};

Map.propTypes = {
  apiKey: PropTypes__default['default'].string.isRequired,
  height: PropTypes__default['default'].string,
  width: PropTypes__default['default'].string,
  mapConfig: PropTypes__default['default'].object,
  position: PropTypes__default['default'].string,
  top: PropTypes__default['default'].string,
  setIsMapLoaded: PropTypes__default['default'].func,
  isMapLoaded: PropTypes__default['default'].bool,
  libraries: PropTypes__default['default'].string
};
Map.defaultProps = {
  height: "100vh",
  width: "100%",
  position: "initial",
  top: "5px",
  isMapLoaded: false,
  setIsMapLoaded: function setIsMapLoaded() {},
  libraries: "",
  mapConfig: DEFAULT_MAP_CONFIG
};

exports.Map = Map;
